<template>
  <div class="page">
    <div id="page-header" class="page-header">
      <HeaderButtons :pageTitle="'商品選択'" :isShowCartButton="true" />
    </div>
    <div id="page-content" class="page-content--shopping">
      <article>
        <div>
          <p class="mb-10 text-caption">
            BSAC JAPAN WEB SHOPPINGでは、BSAC JAPANオリジナル商品を販売しています。<br />
            ダイブセンターまたはメンバーの方は、右上の「ログイン」ボタンからログインをしてご利用ください。
          </p>
        </div>
        <div>
          <v-select
            :items="productCategoriesForSelectBox"
            item-text="nameJa"
            item-value="id"
            v-model="selectedProductCategory"
            label="商品カテゴリで絞り込む"
            filled
            hide-details="false"
            return-object
            class="input-form__selectbox--small"
          ></v-select>
        </div>
        <v-container fluid>
          <v-row>
            <v-col v-for="product in products" :key="product.id" cols="12" md="6" lg="4" xl="3">
              <ProductListItem :product="product" />
            </v-col>
          </v-row>
        </v-container>
      </article>
    </div>
  </div>
</template>

<script>
import HeaderButtons from 'vues/shopping-order/components/parts/HeaderButtons';
import ProductListItem from 'vues/shopping-order/components/parts/ProductListItem';
import selections from 'constant/selections.js';

export default {
  components: {
    HeaderButtons,
    ProductListItem,
  },
  computed: {
    /**
     * 商品カテゴリ一覧を取得する
     */
    productCategories: {
      cache: false,
      get() {
        return this.$store.getters['productCategory/productCategories'];
      },
    },
    /**
     * 商品カテゴリ一覧を取得する
     */
    productCategoriesForSelectBox: {
      cache: false,
      get() {
        return this.$store.getters['productCategory/productCategoriesForSelectBox'];
      },
    },
    /**
     * 商品一覧を取得する
     */
    products: function () {
      const categoryId = this.selectedProductCategory
        ? this.selectedProductCategory.id
        : selections.notSelected;
      return this.$store.getters['product/productsByCategory'](categoryId);
    },
  },
  async created() {
    this.$store.commit('loading/show');
    try {
      // 商品カテゴリ一覧を取得する
      await this.$store.dispatch('productCategory/getProductCategories');
      // 商品一覧を取得する
      await this.$store.dispatch('product/getProducts');
      // 注文情報をリセットする
      if (process.env.RAILS_ENV === 'development') {
        // テスト用データをセットする
        //this.$store.commit('shoppingOrder/resetForTest');
      } else {
        // 入力項目をクリアする
        //this.$store.commit('shoppingOrder/reset');
      }
    } finally {
      this.$store.commit('loading/close');
    }
  },
  data() {
    return {
      selectedProductCategory: {
        id: selections.notSelected,
      },
    };
  },
  methods: {},
};
</script>

<style lang="scss" scoped>
@import 'stylesheets/debug.scss';
@import 'stylesheets/input-form.scss';
@import 'stylesheets/page.scss';
</style>
